import {Group, Paper, Stack, Text} from "@mantine/core";
import CGT from "../../../utils/CGT.ts";
import {WarningIcon, CheckIcon} from "@phosphor-icons/react";


const errorDisplay: Record<string, string> = {
  auth_error: 'Authentication error',
  parse_error: 'Parsing error'
};


const SyncErrorWarning = ({errorType, value}: { errorType: string, value: number }) => {

  const display: string = errorDisplay[errorType] || errorType;
  return (
    <Group gap={4} align="center">
      <WarningIcon color="red"/>
      <Text size="sm">{display}: {value}</Text>
    </Group>
  )
}

const SyncOk = ({value}: { value: number }) => {
  return (
    <Group gap={4} align="center">
      <CheckIcon color="green"/>
      <Text size="sm">Success: {value}</Text>
    </Group>
  )
}

export default function SyncStatus ({status, lastSync}: {status: Record<string, number>, lastSync: number|null}) {
  const date = lastSync ? CGT.fromSeconds(lastSync) : null;
  const diff = date ? CGT.now().diff(date) : null

  const entries = Object.entries(status);
  const ok = entries.filter(([key]) => key === 'ok');
  const errors = entries.filter(([key]) => key !== 'ok');

  console.log('days', diff?.as('days'))

  return (
    <Paper withBorder p="md">
      <Text fw={700}>Sync status</Text>
      {date === null || !date.isValid ? (
        <Text size="sm" c="orange">Last sync not available</Text>
      ) : (
        <Text size="sm" c={!diff || diff.as('days') > 2 ? 'red' : 'dimmed'}>Last sync: {date.toFormat('yyyy-LL-dd HH:mm')} ({date.toRelative()})</Text>
      )}
      <Stack gap={4} mt="sm">
        {ok.map(([key, value]) => <SyncOk key={key} value={value} />)}
        {errors.map(([key, value]) => <SyncErrorWarning key={key} errorType={key} value={value}/>)}
        {Object.keys(status).length === 0 ? <Text size="sm" c="dimmed">No sync data yet.</Text> : null}
      </Stack>
    </Paper>
  )

}
